module.exports = __webpack_public_path__ + "static/media/light-wallet-connect.1d49f2eb.svg";